import * as React from 'react';

export type BadgeVariant = 'success' | 'warning' | 'error' | 'neutral';

export interface BadgeProps {
  variant?: BadgeVariant;
  className?: string;
  children: React.ReactNode;
}

export function Badge({ variant = 'neutral', className, children }: BadgeProps) {
  const variantClass = {
    success: 'badge-success',
    warning: 'badge-warning',
    error: 'badge-error',
    neutral: 'badge-neutral',
  }[variant];

  return <span className={['badge', variantClass, className].filter(Boolean).join(' ')}>{children}</span>;
}
